import React from 'react';
import Experience from '../components/sections/Experience';
import styled from 'styled-components';

const ExperiencePage = () => {
    return (
        <PageContainer>
            <Experience />
        </PageContainer>
    );
};

const PageContainer = styled.div`
  padding-top: 80px; // To account for fixed header
`;

export default ExperiencePage;
